import React, { useContext, useEffect } from "react";
import "../assets/templates/EndLesson.css";
import lessonEnd from "../assets/images/lesson-end.png";
import { Link } from "react-router-dom";
import { AppGlobalConfigContext } from "../providers/AppGlobalConfigContext";
import { WIZME_URL } from "../helpers/constants";
import { useLessonPlaybackState } from "../hooks/useLessonPlaybackState";

const EndLesson = ({ lessonId, catchupId }) => {
  const context = useContext(AppGlobalConfigContext);
  const { isEmbedMode } = context;
  const { reset } = useLessonPlaybackState();

  useEffect(() => {
    reset();
  }, []);

  // Retrieve lessons and batch information
  const lessons = JSON.parse(sessionStorage.getItem("last-accessed-lessons"));
  const batch = localStorage.getItem("blockName");

  return (
    <div
      className="default-card workbook-container new-bg-color"
      style={{ color: "#003057" }}
    >
      <div>
        <img alt="WorkBook" className="workbook-img" src={lessonEnd} />
      </div>
      <div style={{ marginTop: 15 }}>
        <h2>Continue Praticando!</h2>
      </div>
      <div
        style={{
          fontWeight: "lighter",
          width: "50%",
          marginTop: 10,
          marginBottom: 15,
        }}
      >
        Agora que você terminou, aproveite o restante da sua aula para continuar
        fazendo mais exercícios no Wiz.me.
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ marginRight: 30 }} className="workbook-button">
          <Link
            to={{
              pathname: `${isEmbedMode ? "/embeddable" : ""}/lessonsList`,
              lessons: lessons,
              batch: batch,
            }}
            onClick={() => {
              localStorage.setItem("lessons", JSON.stringify(lessons));
              localStorage.setItem("blockName", `Batch: ${batch}`);
            }}
          >
            Voltar para lessons
          </Link>
        </div>
        <a className="workbook-button" href={WIZME_URL} target="_blank">
          Acessar exercícios online
        </a>
      </div>
    </div>
  );
};

export default EndLesson;
